'use client'

import React from 'react'

interface CustomRadioButtonProps {
  id: string
  name: string
  checked: boolean
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  label: string
  className?: string
}

const CustomRadioButton: React.FC<CustomRadioButtonProps> = ({
  id,
  name,
  checked,
  onChange,
  label,
  className = '',
}) => {
  return (
    <label htmlFor={id} className={`flex cursor-pointer items-center ${className}`}>
      {/* hide the native radio, but keep it accessible */}
      <input
        id={id}
        type="radio"
        name={name}
        checked={checked}
        onChange={onChange}
        className="peer sr-only"
      />

      {/* custom box: 16×16px, circular, 1px border */}
      <span className="flex h-4 w-4 items-center justify-center rounded-full border border-gray-300 transition-colors peer-checked:border-[#7F56D9]">
        {/* purple inner dot (6×6px) */}
        <span
          className={`h-1.5 w-1.5 scale-0 transform rounded-full bg-[#7F56D9] ${checked ? 'scale-100 opacity-100' : 'opacity-0'} transition-opacity transition-transform duration-150 ease-in-out`}
        ></span>
      </span>

      <span className="font-space-grotesk ml-2 select-none text-sm font-medium leading-6 text-gray-900">
        {label}
      </span>
    </label>
  )
}

export default CustomRadioButton
